import { IAccreditationsConfig } from '@orcha/types/package';
import { IMicrositeConfiguration } from 'src/interfaces/microsite';
import { SearchService } from 'src/services';
import { Services } from 'src/services/types';
import { myContainer } from 'src/services/inversify.config';

export const appCardDataFetcher = (
  widgetId: string,
  site: IMicrositeConfiguration,
  widgetConfiguration: any,
  language?: string | undefined,
  country?: string | undefined,
  accreditationsConfig?: IAccreditationsConfig
) => {
  const searchService = myContainer.get<SearchService>(Services.SearchService);

  const getResults = async () => {
    const result = await searchService.getAppById(
      site.tenantId,
      site.packageId,
      site.appContainerId,
      widgetConfiguration.appId,
      language,
      country,
      accreditationsConfig
    );

    return { widgetId, result };
  };

  return getResults();
};
